import { useContext } from "react";
import { Card, CardContent, Box, Typography, IconButton } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { Emoji } from "emoji-picker-react";
import { ActivitiesContext } from "../../context/activities/ActivitiesContext";
import { DEFAULT_ACTIVITY_COLOR } from "../../constants/pickerColors";

const ActivityCard = ({ activity }) => {
  const { openEditDialog, handleDelete } = useContext(ActivitiesContext);

  return (
    <Card
      className="activities-page__card"
      sx={{
        borderLeft: `4px solid ${activity.color || DEFAULT_ACTIVITY_COLOR}`,
        "@media (max-width: 359px)": {
          margin: 0,
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          py: 1.5,
          px: 2,
          "&:last-child": { pb: 1.5 },
          "@media (max-width: 359px)": {
            py: 0.75,
            px: 1,
            "&:last-child": { pb: 0.75 },
          },
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: activity.color || DEFAULT_ACTIVITY_COLOR,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
          }}
        >
          <Emoji unified={activity.emoji || "1f4cb"} size={28} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            {activity.name}
          </Typography>
          {activity.description && (
            <Typography variant="body2" color="text.secondary">
              {activity.description}
            </Typography>
          )}
        </Box>
        <IconButton size="small" onClick={() => openEditDialog(activity)}>
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={() => handleDelete(activity)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </CardContent>
    </Card>
  );
};

export default ActivityCard;
